import { TenantEntity } from '../TenantEntity'
import { ApiCacheManage } from '@/utils/commonUtil'
import { checkCreditInfo } from '@/api/partner/creditInfo'

// checkCreditInfo缓存管理
const checkCreditInfoCache = new ApiCacheManage(checkCreditInfo)

export class CreditInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get creditDateType() {
    return this._data.creditDateType
  }
  set creditDateType(creditDateType) {
    this._data.creditDateType = creditDateType || -1
  }
  get creditDateLimited() {
    return this._data.creditDateLimited
  }
  set creditDateLimited(creditDateLimited) {
    this._data.creditDateLimited = creditDateLimited || 0
  }
  get termUnit() {
    return this._data.termUnit
  }
  set termUnit(termUnit) {
    this._data.termUnit = termUnit || 0
  }
  get credit() {
    return this._data.credit
  }
  set credit(credit) {
    this._data.credit = credit || 0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency || 'RMB'
  }
  get blacklist() {
    return this._data.blacklist
  }
  set blacklist(blacklist) {
    this._data.blacklist = blacklist || false
  }
  get usedAmount() {
    return this._data.usedAmount
  }
  set usedAmount(usedAmount) {
    this._data.usedAmount = usedAmount || 0
  }
  get arAmount() {
    return this._data.arAmount
  }
  set arAmount(arAmount) {
    this._data.arAmount = arAmount || 0
  }
  get amountExceeded() {
    return this._data.amountExceeded
  }
  set amountExceeded(amountExceeded) {
    this._data.amountExceeded = amountExceeded || false
  }
  get dateExceeded() {
    return this._data.dateExceeded
  }
  set dateExceeded(dateExceeded) {
    this._data.dateExceeded = dateExceeded || false
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks || 'ETD'
  }
  get receivableDeposit() {
    return this._data.receivableDeposit
  }
  set receivableDeposit(receivableDeposit) {
    this._data.receivableDeposit = receivableDeposit || false
  }
  get depositCurrency() {
    return this._data.depositCurrency
  }
  set depositCurrency(depositCurrency) {
    this._data.depositCurrency = depositCurrency || 'RMB'
  }
  get depositAmount() {
    return this._data.depositAmount
  }
  set depositAmount(depositAmount) {
    this._data.depositAmount = depositAmount || 0
  }
  get depositDate() {
    return this._data.depositDate
  }
  set depositDate(depositDate) {
    this._data.depositDate = depositDate
  }
  get depositType() {
    return this._data.depositType
  }
  set depositType(depositType) {
    this._data.depositType = depositType || 0
  }
  get creditRemarks() {
    return this._data.creditRemarks
  }
  set creditRemarks(creditRemarks) {
    this._data.creditRemarks = creditRemarks
  }
  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid
  }
  get snapCreditDateLimited() {
    return this._data.snapCreditDateLimited
  }
  set snapCreditDateLimited(snapCreditDateLimited) {
    this._data.snapCreditDateLimited = snapCreditDateLimited || 0
  }
  get snapCredit() {
    return this._data.snapCredit
  }
  set snapCredit(snapCredit) {
    this._data.snapCredit = snapCredit || 0
  }
  get snapCurrency() {
    return this._data.snapCurrency
  }
  set snapCurrency(snapCurrency) {
    this._data.snapCurrency = snapCurrency
  }
  get snapTermUnit() {
    return this._data.snapTermUnit
  }
  set snapTermUnit(snapTermUnit) {
    this._data.snapTermUnit = snapTermUnit || 0
  }
  get blacklistRemark() {
    return this._data.blacklistRemark
  }
  set blacklistRemark(blacklistRemark) {
    this._data.blacklistRemark = blacklistRemark
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  // 检查放账信息缓存
  static async checkCreditInfo(companyId, job) {
    // return await checkCreditInfoCache.execute({ [companyId]: companyId })
    return await checkCreditInfo({ [companyId]: companyId }, job)
  }
  // 清空缓存
  static clearCache(companyId) {
    checkCreditInfoCache.clear(ApiCacheManage.toSortString({ [companyId]: companyId }))
  }
}
